function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2202 38.0387H0.823286C0.363778 38.0387 0 37.6749 0 37.2154C0 36.7559 0.363778 36.3921 0.823286 36.3921H37.2202C37.6797 36.3921 38.0435 36.7559 38.0435 37.2154C38.0435 37.6749 37.6797 38.0387 37.2202 38.0387Z",
  fill: "#005885"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3245 38.0386C21.865 38.0386 21.5012 37.6749 21.5012 37.2154V15.7142H16.5423V37.2154C16.5423 37.6749 16.1785 38.0386 15.719 38.0386C15.2595 38.0386 14.8958 37.6749 14.8958 37.2154V15.7142C14.8958 14.7952 15.6425 14.0676 16.5423 14.0676H21.5012C22.4202 14.0676 23.1478 14.8143 23.1478 15.7142V37.2154C23.1478 37.6749 22.784 38.0386 22.3245 38.0386Z",
  fill: "#005885"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5835 38.0385C11.124 38.0385 10.7602 37.6748 10.7602 37.2152V23.162H5.80136V37.2152C5.80136 37.6748 5.43758 38.0385 4.97807 38.0385C4.51856 38.0385 4.15479 37.6748 4.15479 37.2152V23.162C4.15479 22.2429 4.90149 21.5154 5.80136 21.5154H10.7602C11.6792 21.5154 12.4068 22.2621 12.4068 23.162V37.2152C12.4068 37.6748 12.043 38.0385 11.5835 38.0385Z",
  fill: "#005885"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0847 38.0387C32.6252 38.0387 32.2614 37.6749 32.2614 37.2154V9.08965C32.2614 8.63014 32.6252 8.26636 33.0847 8.26636H34.6738L29.7724 2.13959L24.871 8.26636H26.4601C26.9196 8.26636 27.2834 8.63014 27.2834 9.08965V37.2154C27.2834 37.6749 26.9196 38.0387 26.4601 38.0387C26.0006 38.0387 25.6368 37.6749 25.6368 37.2154V9.91293H23.1478C22.8223 9.91293 22.5351 9.74062 22.4011 9.45343C22.2671 9.16623 22.3054 8.8216 22.4969 8.5727L29.1214 0.301552C29.4278 -0.100517 30.0979 -0.100517 30.4042 0.301552L37.0288 8.5727C37.2203 8.8216 37.2586 9.16623 37.1245 9.45343C36.9905 9.74062 36.7033 9.91293 36.3778 9.91293H33.8888V37.2154C33.8888 37.6749 33.525 38.0387 33.0655 38.0387H33.0847Z",
  fill: "#005885"
});

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.f410569d.svg";
export { ForwardRef as ReactComponent };